var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"menu-item",class:{ 'is-active': _vm.isActive ? _vm.isActive(): null },attrs:{"title":_vm.title},on:{"click":_vm.action}},[(_vm.icon)?_c('icon',{attrs:{"name":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }